import { z } from "zod/v4";

export const JsonSchema = z.json();
export type Json = z.infer<typeof JsonSchema>;

/** Parses a string of JSON lines into an array of JSON values. */
export const parseLineJson = (text: string): Json[] =>
  text.split("\n").map((string) => JSON.parse(string));

const replacer = (_key: string, value: unknown) => {
  if (value instanceof Date) {
    return { $type: "Date", value: value.toISOString() };
  } else if (value instanceof Map) {
    return { $type: "Map", value: Array.from(value.entries()) };
  } else if (value instanceof Set) {
    return { $type: "Set", value: Array.from(value) };
  }
  return value;
};

/** Serializes a value to a JSON string, preserving Date, Map, and Set instances. */
export const serialize = (value: unknown): string =>
  JSON.stringify(value, replacer);

const reviver = (_key: string, value: unknown) => {
  if (typeof value !== "object" || value === null) {
    return value;
  }
  const { $type, value: innerValue } = value as {
    $type: string;
    value: unknown;
  };
  if ($type === "Date") {
    return new Date(innerValue as string);
  } else if ($type === "Map") {
    return new Map(innerValue as [unknown, unknown][]);
  } else if ($type === "Set") {
    return new Set(innerValue as unknown[]);
  }
  return value;
};

/** Parses a JSON string, restoring Date, Map, and Set instances. */
export const deserialize = (text: string): unknown => JSON.parse(text, reviver);
